export default __webpack_public_path__ + "static/media/blogcard4.94ff6102.png";